export default [
  // settings
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/views/pages/settings/Settings.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Settings',
          active: true,
        },
      ],
      level: 3,
    },
  },
  // user group
  {
    path: '/usergroup',
    name: 'usergroup',
    component: () => import('@/views/pages/usergroup/List.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'User Groups',
          active: true,
        },
      ],
      level: 3,
    },
  },
  // user group detail
  {
    path: '/userGroupDetail/:id',
    name: 'userGroupDetail',
    component: () => import('@/views/pages/usergroup/Detail.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'User Group List',
          to: '/usergroup',
        },
        {
          text: 'User Group Details',
          active: true,
        },
      ],
      level: 3,
    },
  },
  // page
  {
    path: '/page',
    name: 'page',
    component: () => import('@/views/pages/page/List.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Pages',
          active: true,
        },
      ],
      level: 3,
    },
  },
  // pdf reports
  {
    path: '/pdfreports',
    name: 'pdfreports',
    component: () => import('@/views/pages/page/PdfReports.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'PDF Reports',
          active: true,
        },
      ],
      level: 3,
    },
  },
  // holiday
  {
    path: '/holiday',
    name: 'holiday',
    component: () => import('@/views/pages/holiday/List.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Holidays',
          active: true,
        },
      ],
      level: 3,
    },
  },
  // hotalertcondition
  {
    path: '/hotalertcondition',
    name: 'hotalertcondition',
    component: () => import('@/views/pages/hotalertcondition/List.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'HotAlert Conditions',
          active: true,
        },
      ],
      level: 3,
    },
  },
  // appeals link
  {
    path: '/appeals',
    name: 'appeals',
    component: () => import('@/views/pages/appeals/List.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Appeals',
          active: true,
        },
      ],
      level: 1,
    },
  },
  // project list
  {
    path: '/project',
    name: 'project',
    component: () => import('@/views/pages/project/List.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Project List',
          active: true,
        },
      ],
      level: 3,
    },
  },
  // project detail
  {
    path: '/projectDetail/:id',
    name: 'projectDetail',
    component: () => import('@/views/pages/project/Detail.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Project List',
          to: '/project',
        },
        {
          text: 'Settings',
          active: true,
        },
      ],
      level: 3,
    },
  },
  // project calculation progress
  {
    path: '/project/calculationprogress',
    name: 'calculationprogress',
    component: () => import('@/views/pages/project/CalculationProgress.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Calculation Progress',
          active: true,
        },
      ],
      level: 3,
    },
  },
  // report
  {
    path: '/report',
    name: 'report',
    component: () => import('@/views/pages/report/Index.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Report',
          active: true,
        },
      ],
      level: 3,
    },
  },
  // user list
  {
    path: '/user',
    name: 'user',
    component: () => import('@/views/pages/user/List.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'User List',
          active: true,
        },
      ],
      level: 3,
    },
  },
  // user detail
  {
    path: '/userDetail/:id',
    name: 'userDetail',
    component: () => import('@/views/pages/user/Detail.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'User List',
          to: '/user',
        },
        {
          text: 'Settings',
          active: true,
        },
      ],
      level: 3,
    },
  },
  // dashboard
  {
    path: '/dashboard/:id',
    name: 'dashboard',
    component: () => import('@/views/dashboard/DashboardNew.vue'),
    meta: {
      level: 1,
    },
  },
  // dashboard for PDF
  {
    path: '/pdf/:id/:encId',
    name: 'pdf',
    component: () => import('@/views/pdf/pdf.vue'),
    meta: {
      layout: 'full',
      level: 0,
    },
  },
  // error-404
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      layout: 'full',
      level: 0,
    },
  },
  // maintenance
  {
    path: '/maintenance',
    name: 'maintenance',
    component: () => import('@/views/maintenance/Maintenance.vue'),
    meta: {
      layout: 'full',
      level: 0,
    },
  },
  // auth-login
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/pages/authentication/Login.vue'),
    meta: {
      layout: 'full',
      level: 0,
      redirectIfLoggedIn: false,
    },
  },
  // auth-login-local
  {
    path: '/login/local',
    name: 'auth-login-local',
    component: () => import('@/views/pages/authentication/LoginLocal.vue'),
    meta: {
      layout: 'full',
      level: 0,
      redirectIfLoggedIn: false,
    },
  },
  // auth-login-local
  {
    path: '/login/ipsos',
    name: 'auth-login-ipsos',
    component: () => import('@/views/pages/authentication/LoginLocal.vue'),
    meta: {
      layout: 'full',
      level: 0,
      redirectIfLoggedIn: false,
    },
  },
  // auth-login-help
  {
    path: '/login-help',
    name: 'auth-login-help',
    component: () => import('@/views/pages/authentication/LoginHelp.vue'),
    meta: {
      layout: 'full',
      level: 0,
      redirectIfLoggedIn: false,
    },
  },
  // auth-forgot-password
  {
    path: '/forgot-password',
    name: 'auth-forgot-password',
    component: () => import('@/views/pages/authentication/ForgotPassword.vue'),
    meta: {
      layout: 'full',
      level: 0,
      redirectIfLoggedIn: false,
    },
  },
  // auth-reset-password
  {
    path: '/reset-password/:resetkey',
    name: 'auth-reset-password',
    component: () => import('@/views/pages/authentication/ResetPassword.vue'),
    meta: {
      layout: 'full',
      level: 0,
      redirectIfLoggedIn: false,
    },
  },
  // sso
  {
    path: '/sso/:key',
    name: 'sso',
    component: () => import('@/views/pages/authentication/Sso.vue'),
    meta: {
      layout: 'full',
      level: 0,
      redirectIfLoggedIn: false,
    },
  },
  // sso v2
  {
    path: '/sso2/:key',
    name: 'sso2',
    component: () => import('@/views/pages/authentication/Sso2.vue'),
    meta: {
      layout: 'full',
      level: 0,
      redirectIfLoggedIn: false,
    },
  },
  // misc-under-maintenance
  {
    path: '/pages/miscellaneous/under-maintenance',
    name: 'misc-under-maintenance',
    component: () => import('@/views/pages/miscellaneous/UnderMaintenance.vue'),
    meta: {
      layout: 'full',
      level: 0,
    },
  },
  // misc-loggedout
  {
    path: '/pages/miscellaneous/loggedout',
    name: 'loggedOut',
    component: () => import('@/views/pages/miscellaneous/LoggedOut.vue'),
    meta: {
      layout: 'full',
      level: 0,
    },
  },
  // misc-error
  {
    path: '/pages/miscellaneous/error',
    name: 'misc-error',
    component: () => import('@/views/pages/miscellaneous/Error.vue'),
    meta: {
      layout: 'full',
      level: 0,
    },
  },
  // misc-not-authorized
  {
    path: '/pages/miscellaneous/not-authorized',
    name: 'misc-not-authorized',
    component: () => import('@/views/pages/miscellaneous/NotAuthorized.vue'),
    meta: {
      layout: 'full',
      level: 0,
    },
  },
  // hotalert
  {
    path: '/hotalert',
    name: 'hotalert',
    component: () => import('@/views/pages/hotalert/List.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Hot Alerts',
          active: true,
        },
      ],
      level: 0,
    },
  },
  // approval
  {
    path: '/approval',
    name: 'approval',
    component: () => import('@/views/pages/approval/List.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Approvals',
          active: true,
        },
      ],
      level: 0,
    },
  },
  // request
  {
    path: '/request',
    name: 'request',
    component: () => import('@/views/pages/request/List.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Requests',
          active: true,
        },
      ],
      level: 0,
    },
  },
  // messages
  {
    path: '/messages',
    name: 'messages',
    component: () => import('@/views/pages/message/List.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Messages',
          active: true,
        },
      ],
      level: 0,
    },
  },
  // library
  {
    path: '/library',
    name: 'library',
    component: () => import('@/views/pages/library/List.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Library',
          active: true,
        },
      ],
      level: 0,
    },
  },
  // scheduled box
  {
    path: '/scheduledbox',
    name: 'scheduledbox',
    component: () => import('@/views/pages/scheduledbox/List.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Scheduled Delivery',
          active: true,
        },
      ],
      level: 3,
    },
  },
  // user group detail
  {
    path: '/scheduledBoxDetail/:id',
    name: 'scheduledBoxDetail',
    component: () => import('@/views/pages/scheduledbox/Detail.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Scheduled Delivery',
          to: '/scheduledbox',
        },
        {
          text: 'Scheduled Delivery Details',
          active: true,
        },
      ],
      level: 3,
    },
  },
]
